<div class="cf-page" *ngIf="configLoaded && form">

  <form [formGroup]="form" (ngSubmit)="submitForm()" class="cf-form">

    <!-- Admin-only "Company test" switch, rendered in the header rather than inside a card
         (Figma node 1653:10622). The Company card excludes this field so it is not drawn twice.
         Positioned absolutely against .cf-form (see company-form.component.scss) so it lands on
         the same visual line as the "New company"/"Edit company" title, which is rendered by the
         shared title bar OUTSIDE this component — same technique as .pod-is-test-checkbox in the
         Purchase Order form. -->
    <div class="cf-header-switch" *ngIf="isAdmin && testCompanyControlName">
      <input
        class="rp-switch"
        id="companytest"
        type="checkbox"
        [formControlName]="testCompanyControlName"
      >
      <label for="companytest">{{ LABELS.TEST_SWITCH }}</label>
    </div>

    <div class="cf-page__head">
      <span class="cf-page__legend">{{ LABELS.REQUIRED_LEGEND }}</span>
    </div>

    <div class="cf-blocking-banner" *ngIf="rebatesBlockSave">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C7.58236 4 4 7.58236 4 12C4 16.4176 7.58236 20 12 20C16.4186 20 20 16.4177 20 12C20 7.58227 16.4186 4 12 4ZM1.5 12C1.5 6.20164 6.20164 1.5 12 1.5C17.7994 1.5 22.5 6.20173 22.5 12C22.5 17.7983 17.7994 22.5 12 22.5C6.20164 22.5 1.5 17.7984 1.5 12ZM11.9951 6.9541C12.6854 6.9541 13.2451 7.51375 13.2451 8.2041V12.6231C13.2451 13.3135 12.6854 13.8731 11.9951 13.8731C11.3047 13.8731 10.7451 13.3135 10.7451 12.6231V8.2041C10.7451 7.51375 11.3047 6.9541 11.9951 6.9541ZM11.9951 14.5459C11.3047 14.5459 10.7451 15.1055 10.7451 15.7959C10.7451 16.4863 11.3047 17.0459 11.9951 17.0459H12.0051C12.6954 17.0459 13.2551 16.4863 13.2551 15.7959C13.2551 15.1055 12.6954 14.5459 12.0051 14.5459H11.9951Z" fill="#FF441F"/>
      </svg>
      <p class="cf-blocking-banner__text">{{ REBATE.TYPE_CHANGED_MESSAGE }}</p>
      <button type="button" class="cf-blocking-banner__action" (click)="removeAllRebates()">
        {{ LABELS.REMOVE_ALL_REBATES }}
      </button>
    </div>

    <div class="cf-sections">
      <div class="cf-saving-overlay" *ngIf="isSaving || configReloading"></div>

      <ng-container *ngFor="let section of sections; trackBy: trackBySectionKey">
        <ng-container *ngIf="isSectionRendered(section)" [ngSwitch]="section.kind">

          <app-company-files-card
            *ngSwitchCase="SECTION_KIND.FILES"
            [section]="section"
            [form]="form"
            [submitted]="submitted"
            [required]="isFileSectionRequired(section)"
            [companyId]="companyId"
            [documentConfig]="documentConfigFor(section)"
            [strictMode]="documentsStrictMode"
          ></app-company-files-card>

          <app-agency-rebates-card
            *ngSwitchCase="SECTION_KIND.REBATES"
            [section]="section"
            [form]="form"
            [submitted]="submitted"
          ></app-agency-rebates-card>

          <app-company-form-section
            *ngSwitchDefault
            [section]="section"
            [form]="form"
            [states]="states"
            [submitted]="submitted"
            [sources]="sources"
            [resolvers]="resolvers"
            [excludedControlNames]="excludedControlNames"
            (underInputClick)="onUnderInputClick($event)"
            (editOptionClick)="onEditOptionClick($event)"
          ></app-company-form-section>

        </ng-container>
      </ng-container>
    </div>

    <div class="cf-footer">
      <button
        type="button"
        class="rp-button rp-outlined rp-primary"
        disabled
        (click)="saveDraft()"
      >
        {{ isSaving ? LABELS.SAVING : LABELS.SAVE_DRAFT }}
      </button>

      <button
        type="submit"
        class="rp-button rp-filled rp-primary"
        disabled
      >
        {{ isSaving ? LABELS.SAVING : (mode === MODE.EDIT ? LABELS.SAVE_CHANGES : LABELS.SUBMIT) }}
      </button>
    </div>

  </form>

</div>
